/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ErrorModel } from '../../model/error.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import { Maybe } from '@irian-ro/util-functions';

//TODO rename to iriro-form-error
@Component({
  selector: 'form-error, iriro-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
})
export class FormErrorComponent implements OnInit, OnChanges {
  @Input() errors: Maybe<ErrorModel | Array<ErrorModel>> | undefined = undefined;
  @Input() langErrorLabelPath: Maybe<string> | undefined = undefined;
  @Input() useGrowl = true;
  @Input() useMessages = true;

  msg: ToastMessageOptions[] = [];

  constructor(
    private readonly translateService: TranslateService,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.triggerErrorDisplay();
  }

  ngOnChanges(): void {
    this.triggerErrorDisplay();
  }

  triggerErrorDisplay() {
    if(this.errors) {
      this.errors = Array.isArray(this.errors) ? this.errors : [this.errors];
      this.msg = [];
      this.errors.map((error: any) => {
        if (error) {
          this.pushErrorsToMessageComponents(
            error.severity || '',
            error.message || '',
            error.detail || ''
          );
        }
      });
    }
  }

  pushErrorsToMessageComponents(severity: string, messageKey: string, messageDetail: string) {
    const langErrorLabelPath = this.langErrorLabelPath;
    if(langErrorLabelPath ) {
      this.translateService
        .stream(`${this.langErrorLabelPath}.${messageKey}`)
        .subscribe((res: string) => {
          this.messageService.clear();
          this.messageService.add({
            severity: severity,
            summary: res,
            detail: messageDetail,
            key: langErrorLabelPath,
          });
          this.msg.push({
            severity: severity,
            summary: res,
            detail: messageDetail,
            key: langErrorLabelPath,
          });
        });
    }
  }
}
